<template>
    <div>
        <PageHeader>
            <div>{{ $t('statistics') }}</div>
            <template #side>
                <div class="page-filters d-flex gap-3 flex-wrap justify-content-end">
                    <div class="d-flex gap-0">
                        <ButtonIcon
                            icon="refresh-cw"
                            variant="link"
                            class="btn-refresh"
                            :disabled="loading"
                            :icon-animation="reloading ? 'spin' : ''"
                            @click="reloadData"
                        />

                        <ButtonIcon
                            icon="x"
                            variant="link"
                            class="text-danger btn-refresh"
                            :disabled="loading"
                            @click="resetFilters"
                        />
                    </div>

                    <div class="filter-inside d-flex gap-3 flex-wrap justify-content-end">

                        <MultiselectCampaigns
                            :initial-value="filters.campaigns"
                            :disabled="loading"
                            :placeholder="$t('campaign')"
                            class="filter-campaigns width-200"
                            @loading="value => isCampaignsLoading = value"
                            @inputTrackBy="filters.campaigns = $event"
                            @change="filterData()"
                        />

                        <MultiselectSpaces
                            :initial-value="filters.spaces"
                            :disabled="loading"
                            :placeholder="$t('space')"
                            class="filter-spaces width-200"
                            @loading="value => isSpacesLoading = value"
                            @inputTrackBy="filters.spaces = $event"
                            @change="filterData()"
                        />

                        <Multiselect
                            :initial-value="filters.groupBy"
                            :options="intervalOptions"
                            :disabled="loading"
                            :allow-empty="false"
                            class="filter-interval width-200"
                            :placeholder="$t('interval')"
                            @inputTrackBy="filters.groupBy = $event"
                            @change="filterData()"
                        />

                    </div>

                    <TimeRangeDropdown
                        :value="timeRangeValue"
                        :disabled="loading"
                        :options="['last7Days', 'currentWeek', 'last14Days', 'last30days', 'currentMonth', 'lastMonth', 'currentQuarter', 'lastQuarter', 'currentYear', 'lastYear', 'custom']"
                        class="filter-time-range"
                        @startDate="filters.startDate = $event"
                        @endDate="filters.endDate = $event"
                        @timeRange="filterData()"
                    />
                </div>
            </template>
        </PageHeader>
        <Chart ref="Chart" />
        <Results ref="Results" />
    </div>
</template>



<script>
    import TimeRangeDropdown, { getDefaultTimeRange } from '@/components/common/TimeRangeDropdown.vue';
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';
    import MultiselectCampaigns from '@/components/common/MultiselectCampaigns.vue';
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Multiselect from '@/components/common/Multiselect.vue';
    import Chart from './parts/Chart.vue';
    import Results from './parts/Results.vue';

    const DEFAULT_TIME_RANGE = getDefaultTimeRange();
    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        startDate: DEFAULT_TIME_RANGE.startDate,
        endDate: DEFAULT_TIME_RANGE.endDate,
        spaces: [],
        campaigns: [],
        groupBy: 'day',
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 20,
        page: 1,
        sort: 'date',
        order: 'DESC',
    });

    export default {
        name: 'ReportsStats',
        mixins: [viewFiltersMixin],
        components: {
            Chart,
            Results,
            TimeRangeDropdown,
            MultiselectSpaces,
            MultiselectCampaigns,
            Multiselect,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('userStats/generalStats'),
            };
        },
        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
            urlParams() {
                return {
                    userId: this.user.id,
                };
            },
            requestParams() {
                return {
                    ...this.requestParamsFilters,
                };
            },
            timeRangeValue() {
                const { startDate, endDate } = this.$route.query;
                const timeRangeValue = startDate && endDate ? { startDate, endDate } : undefined;
                return timeRangeValue;
            },
            intervalOptions() {
                return [
                    { text: this.$t('day'), value: 'day' },
                    { text: this.$t('month'), value: 'month' },
                    { text: this.$t('quarter'), value: 'quarter' },
                    { text: this.$t('year'), value: 'year' },
                ];
            },
        },
        methods: {
            resetFilters() {
                this.resetData();
            },
        },
    };
</script>



<style lang="scss" scoped>
    @media (max-width: map-get($grid-breakpoints, 'sm')) {
        .page-filters {
            .btn-refresh {
                order: 1;
            }
            .filter-campaigns {
                width: 120px !important;
                order: 3;
            }
            .filter-spaces {
                width: 120px !important;
                order: 4;
            }
            .filter-interval {
                width: 120px !important;
                order: 5;
            }
            .filter-time-range {
                order: 2;
            }
            .filter-inside {
                order: 3;
            }
        }
    }
</style>

